import * as _ from "lodash";
import { ApiError } from "./ApiError";
import { SystemImportApi } from "./SystemImportApi";
import { SystemNotificationApi } from "./SystemNotificationApi";

export class ApiClient {
	public systemImport: SystemImportApi;
	public systemNotification: SystemNotificationApi;

	constructor() {
		this.systemImport = new SystemImportApi(this);
		this.systemNotification = new SystemNotificationApi(this);
	}

	/**
	 * Small wrapper around the `fetch` function, directly returns the json
	 * @throws Will throw if the response isn't valid JSON
	 * @param url url to fetch
	 * @param init additional options passed to fetch function
	 */
	public async fetchJson(url: RequestInfo, init: RequestInit) {
		let res = await fetch(url, init);
		return await res.json();
	}

	/**
	 * Makes a RPC call to the API
	 * @param method PRC Method to call
	 * @param params params Object to pass
	 */
	public async callCfc(method: string, params: any) {
		let res = await this.fetchJson(`/dynasite.cfm?dscmd=system_rpc_rpc_call`, {
			method: "post",
			credentials: "include",
			body: JSON.stringify({ method, params }),
		});

		if (res.error != null) {
			throw new ApiError(res.error.code, res.error.message, res.error.data);
		}

		if (res.DEBUG != null) {
			this.logSpan(res.DEBUG, res.DEBUG.requestId);
		}

		return res.result;
	}

	/**
	 * Print debugging info about the given span to the `console`
	 * @param DEBUG the DEBUG object returned from the Request
	 * @param id ID of the span to print
	 * @param indent internal param for recursion, set indention level
	 */
	private logSpan(DEBUG, id, indent = 0) {
		let thisSpan = _.find<any>(DEBUG.spans, (s) => s.spanId === id);

		// tslint:disable:no-console
		if (thisSpan == null) {
			console.log(_.repeat("  ", indent) + `- ${id}`);
		} else {
			console.log(_.repeat("  ", indent) + `- ${thisSpan.method} (${thisSpan.time}ms)`);
		}
		// tslint:enable:no-console

		let spans = _.filter<any>(DEBUG.spans, (s) => s.parent === id);
		for (let span of spans) {
			this.logSpan(DEBUG, span.spanId, indent + 1);
		}
	}
}



// WEBPACK FOOTER //
// ./src/lib/api/ApiClient.ts